<script setup lang="ts">
  import { getAndClearRedirectUrl } from '@/shared/lib/router'

  import { useProfile } from '@/entities/profile'

  definePage({
    meta: {
      layout: 'fullscreenLoading',
    },
  })

  const profileStore = useProfile()
  const { initProfile } = profileStore
  const router = useRouter()

  onMounted(async () => {
    const user = await initProfile()

    if (!user) {
      return // handleProfileError in store handles redirect
    }

    const redirectUrl = getAndClearRedirectUrl() || '/'
    await router.push(redirectUrl)
  })
</script>

<template>
  <div />
</template>
